import React, { useState, useContext, useEffect } from 'react'

import { Form, Input, Modal } from 'antd'

import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api'
import SL_Button from '../../components/buttons/Button';
import { MaskedInput } from 'antd-mask-input'
import SL_Date from '../../components/dates/Date';
import moment from 'moment'
import { displayMessage } from '../../services/helper';

const inputsClassName = `border-appian-blue max-h-9 text-base`

export default function DetailMonitor(props) {

    const [form] = Form.useForm()

    const [monitor, setMonitor] = useState(null)
    const [edit_mode, setEditMode] = useState(false)

    const { setShowLoading, windowHeight} = useContext(GeneralContext)
    
    useEffect(() => {
        loadMonitor()
    }, [])

    function loadMonitor() {
        setShowLoading(true)

        api.monitor.get(props.monitor_id)
            .then(
                rs => {
                    rs.data.birth_date = moment(rs.data.birth_date)
                    setMonitor(rs.data)
                    
                    form.setFieldsValue(rs.data)
                }
            )
            .finally(
                setShowLoading(false)
            )
    }

    const handleUpdateMonitor = (values) => {
        setShowLoading(true)
        values.id = monitor.id
        
        api.monitor.update(values)
            .then(
                rs => {                    
                    alert(displayMessage('CREATE_MONITOR_SUCCESS'), 'success', displayMessage('SUCCESS'))
                    props.refreshMonitors()
                }
            ).finally(
                () => {
                    setShowLoading(false)
                    props.handleOnCloseModal()
                }
            )
    }

    const cpfField = placeholder => {
        if (edit_mode) {
            return (
                <MaskedInput
                    type="text"
                    size='large'
                    placeholder={placeholder}
                    className={inputsClassName}
                    defaultValue={monitor?.cpf}
                    mask={'000.000.000-00'}
                />
            )
        } else {
            return (
                <div style={{ fontSize: 16, border: '1px solid #1c3663', padding: 5, paddingTop: 4, paddingLeft: 11, background: '#f5f5f5', color: '#b7b7b7' }}>
                    { monitor?.cpf }
                </div>
            )
        }

    }

    const modalHeader = (
            <div className="flex flex-row">
                <div className="text-xl font-bold text-appian-blue">
                    {displayMessage('DETAIL_MONITOR')}
                </div>
                <div style={{ marginLeft: 10}}>
                    <SL_Button
                        type={edit_mode ? "danger" : "primary"}
                        styles={{ maxWidth: 100 }}
                        htmlType="submit"
                        className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                        onClick={
                            e => {
                                setEditMode(!edit_mode)
                                form.setFieldsValue(monitor)
                            }
                        }
                    >
                        {edit_mode ? displayMessage('CANCEL') : displayMessage('EDIT')}
                    </SL_Button>
                </div>
                
            </div>
    )
            
        
    return (
        <Modal
            title={modalHeader}
            visible={props.isModalVisible}
            onCancel={props.handleOnCloseModal}
            centered={true}
            width={750}
            style={{position: 'relative'}}
            bodyStyle={{ maxHeight: windowHeight*0.8, overflow: 'auto'}}
        >
            <Form
                className='w-full flex flex-col gap-2 p-5'
                onFinish={handleUpdateMonitor}
                layout="vertical"
                requiredMark='optional'
                form={form}
            >
            <div>
                <div className='font-bold text-lg text-appian-blue text-center'>{displayMessage('MONITOR_DATA')}</div>
                    <Form.Item
                        label={displayMessage('NAME')}
                        name="first_name"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                    >
                        <Input
                            type="text"
                            size='large'
                            disabled={!edit_mode}
                            placeholder={displayMessage('NAME')}
                            className={inputsClassName}
                        />
                    </Form.Item>
                    <Form.Item
                        label={displayMessage('LAST_NAME')}
                        name="last_name"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('FULL_NAME_MANDATORY') }]}
                    >
                        <Input
                            type="text"
                            size='large'
                            disabled={!edit_mode}
                            placeholder={displayMessage('LAST_NAME')}
                            className={inputsClassName}

                        />
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('CPF')}
                        name="cpf"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('CPF') }]}
                    >
                        {
                            cpfField(displayMessage('CPF'))
                        }
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('BIRTHDAY')}
                        name="birth_date"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('CPF') }]}
                    >
                        <SL_Date
                            className={inputsClassName}
                            disabled={!edit_mode}
                            style={{ width: '100%', height: 110}}
                            format={'DD/MM/YYYY'}
                        />
                    </Form.Item>

                    <Form.Item
                        label={displayMessage('IDENTIFICATOR_MONITOR')}
                        name="identificator"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('IDENTIFICATOR_MONITOR') }]}
                    >
                        <Input
                            type="text"
                            size='large'
                            disabled={!edit_mode}
                            placeholder={displayMessage('IDENTIFICATOR_MONITOR')}
                            className={inputsClassName}

                        />
                    </Form.Item>
                
                    <Form.Item
                        label={displayMessage('EMAIL')}
                        name="email"
                        className={`w-full flex`}
                        rules={[{ required: true, message: displayMessage('EMAIL'), type: "email", }]}
                    >
                        <Input
                            type="email"
                            size='large'
                            disabled={!edit_mode}
                            placeholder={displayMessage('EMAIL')+displayMessage('EMAIL_EXEMPLE')}
                            className={inputsClassName}

                        />
                    </Form.Item>
                    {
                        edit_mode ?
                        <SL_Button
                            type="primary"
                            size='large'
                            htmlType="submit"
                            className="border-appian-blue max-h-9 text-base w-full sticky bottom-[-20px]"
                        >
                            {displayMessage('UPDATE_MONITOR')}
                        </SL_Button>
                        :
                        null
                    }
                </div>
            </Form>
        </Modal >
    )
}

